/**
 * Relationships API
 *
 * API functions for managing saved relationships (other people's charts).
 */

import { get, del, put, post } from './client';
import type { Relationship } from '../types';

interface RelationshipsResponse {
  relationships: Relationship[];
}

export interface UpdateRelationshipData {
  name?: string;
  relationship_type?: string;
  notes?: string;
  birth_date?: string;
  birth_time?: string;
  birth_place?: string;
}

/**
 * Get all relationships for the current user
 */
export async function getRelationships(): Promise<Relationship[]> {
  const response = await get<RelationshipsResponse>('/api/relationships');
  return response.relationships || [];
}

/**
 * Update a relationship by ID
 */
export async function updateRelationship(id: number, data: UpdateRelationshipData): Promise<Relationship> {
  return put<Relationship>(`/api/relationships/${id}`, data as Record<string, unknown>);
}

/**
 * Delete a relationship by ID
 */
export async function deleteRelationship(id: number): Promise<void> {
  await del(`/api/relationships/${id}`);
}

/**
 * Get today's transits for a relationship (cached)
 */
export async function getRelationshipTransits(id: number): Promise<Record<string, unknown>> {
  return get<Record<string, unknown>>(`/api/relationships/${id}/transits`);
}

/**
 * Regenerate synastry summary for a relationship
 */
export async function regenerateSummary(id: number): Promise<void> {
  await post(`/api/relationships/${id}/summary`, {});
}
